(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeeDialogController', EmployeeDialogController);

    /* Added $locale
    EmployeeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Employee', 'User', 'Division', 'EmployeePhone'];

    function EmployeeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Employee, User, Division, EmployeePhone) {
    */
    EmployeeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Employee', 'User', 'Division', 'EmployeePhone', '$locale'];

    function EmployeeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Employee, User, Division, EmployeePhone, $locale) {
        var vm = this;

        vm.employee = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        /*
        vm.users = User.query();
        vm.divisions = Division.query();
        // Лишний запрос всех телефонов
        vm.employeephones = EmployeePhone.query();
        */
        vm.users = User.query({size: 9999, sort: 'login,asc'});
        vm.divisions = Division.query({size: 9999, sort: 'title,asc', actual: false});
        vm.dateformat = $locale.DATETIME_FORMATS.shortDate;
        vm.calcProps = calcProps;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.employee.id !== null) {
                Employee.update(vm.employee, onSaveSuccess, onSaveError);
            } else {
                Employee.save(vm.employee, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:employeeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.birthday = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function calcProps() {
            if (vm.employee.name == null || vm.employee.surname == null || vm.employee.patronymic == null) {
                vm.employee.fullname = null;
                vm.employee.briefname = null;
                return;
            }
            var NON_BREAKING_SPACE = '\u00A0';
            vm.employee.fullname = vm.employee.surname + " " + vm.employee.name + " " + vm.employee.patronymic;
            vm.employee.briefname = vm.employee.surname + NON_BREAKING_SPACE + vm.employee.name.charAt(0) + "."
                    + NON_BREAKING_SPACE + vm.employee.patronymic.charAt(0) + ".";
        }
    }
})();
